/* eslint-disable max-len */
export const findCategory = (state) => (id) => state.all.find((category) => category.id === id);
export const findProductInCurrent = (state) => (id) => state.current.products.find((product) => product.id === id);
